import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      id: 'ssl',
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: 'Your data is protected with 256-bit SSL encryption'
    },
    {
      id: 'secure',
      icon: 'Lock',
      title: 'Secure Authentication',
      description: 'Multi-layer security with token-based authentication'
    },
    {
      id: 'privacy',
      icon: 'Eye',
      title: 'Privacy Protected',
      description: 'We never share your credentials or personal data'
    }
  ];

  return (
    <div className="mt-8 space-y-4">
      <div className="text-center">
        <h3 className="text-sm font-medium text-foreground mb-4">Security & Trust</h3>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {securityFeatures?.map((feature) => (
          <div
            key={feature?.id}
            className="flex items-start space-x-3 p-3 bg-muted/30 rounded-lg"
          >
            <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={14} className="text-success" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">{feature?.title}</p>
              <p className="text-xs text-muted-foreground mt-1">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-center space-x-4 pt-4 border-t border-border">
        <div className="flex items-center space-x-2">
          <Icon name="Shield" size={16} className="text-success" />
          <span className="text-xs text-muted-foreground">SSL Secured</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="CheckCircle" size={16} className="text-success" />
          <span className="text-xs text-muted-foreground">GDPR Compliant</span>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;